import React from 'react';
import { motion } from 'framer-motion';
import { HomeIcon, Building2Icon, BedDoubleIcon, SparklesIcon, HardHatIcon, BoxIcon } from 'lucide-react';
const MARBLE = 'https://cdn.magicpatterns.com/uploads/jqDofBNCB79QMBc7jXj4vw/marmoldetalle.webp';
interface Service {
  icon: BoxIcon;
  title: string;
  desc: string;
}
const SERVICES: Service[] = [{
  icon: HomeIcon,
  title: 'Residential Cleaning',
  desc: 'Recurring and one-time cleans that keep your home effortlessly pristine.'
}, {
  icon: Building2Icon,
  title: 'Commercial Cleaning',
  desc: 'Polished offices and workspaces that make the right impression.'
}, {
  icon: BedDoubleIcon,
  title: 'Airbnb Specialist',
  desc: 'Fast, hotel-standard turnovers with linens and staging between guests.'
}, {
  icon: SparklesIcon,
  title: 'Deep Cleaning',
  desc: 'A meticulous top-to-bottom reset for every corner of your space.'
}, {
  icon: HardHatIcon,
  title: 'Post-Construction',
  desc: 'Dust, debris and residue removed so your new space truly shines.'
}];
export function ServicesGrid() {
  return <section id="services" className="relative w-full overflow-hidden" data-id="element-233" data-mp="31qku54kmpd04">
      <img src={MARBLE} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-10" data-id="element-234" data-mp="2nqtivblhyapt" />
      <div className="absolute inset-0 bg-white/70" data-id="element-235" data-mp="2sqy0j4y55bhm" />

      <div className="relative z-10 mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-32" data-id="element-236" data-mp="3gfqoof8iuf1o">
        <div className="mx-auto max-w-2xl text-center" data-id="element-237" data-mp="3le1wylj64hhs">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-magenta" data-id="element-238" data-mp="3lflesgkh30lo">
            Our Services
          </span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate" data-id="element-239" data-mp="3bnfmt6u80j6h">
            Cleaning, elevated to a craft
          </h2>
          <p className="mt-4 text-slate-soft" data-id="element-240" data-mp="362txchctgsx">
            A full suite of boutique services, each delivered with the same
            detail and care.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:mt-14 sm:grid-cols-2 lg:grid-cols-5" data-id="element-241" data-mp="hu33twzk3zze">
          {SERVICES.map(({
          icon: Icon,
          title,
          desc
        }, i) => <motion.article key={title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.06
        }} className="group flex flex-col rounded-2xl border border-slate-100 bg-white/90 p-6 shadow-[0_2px_24px_rgba(15,23,42,0.05)] backdrop-blur-sm transition-all hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(15,23,42,0.10)]" data-id="element-242" data-mp="7vx33iphkzw4" data-mpi={i}>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-magenta-soft text-magenta transition-colors group-hover:bg-magenta group-hover:text-white" data-id="element-243" data-mp="37cv1po7evcu1">
                <Icon className="h-5 w-5" strokeWidth={2} data-id="element-244" data-mp="1rsckzjk6sras" />
              </span>
              <h3 className="mt-5 font-display text-base font-bold text-slate" data-id="element-245" data-mp="1vufy0cmi83y6">
                {title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-muted" data-id="element-246" data-mp="20u29ohmopc4v">
                {desc}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}